import React from 'react';
import {
  FooterBuildContainer,
  FooterCopyrightContainer,
  FooterLink,
  FooterText,
  FooterWrapper,
} from './styling';
import { FooterProps } from './types';
import { DATALOADER_BUILD_VERSION } from '@55degrees/aa-azure-dataloader';
import useBackendContext from '../../hooks/useBackendContext';

function Footer({ isDarkMode }: FooterProps) {
  const backendContextQuery = useBackendContext();
  const { VITE_BUILD_NUMBER = '' } = import.meta.env;
  const { buildKey: backendBuildKey } = backendContextQuery.data ?? { buildKey: '' };
  const copyrightStartYear = '2023';
  const copyrightEndYear = new Date().getFullYear();

  return (
    <FooterWrapper isDarkMode={isDarkMode}>
      <FooterBuildContainer>
        <FooterText isDarkMode={isDarkMode}>
          F{VITE_BUILD_NUMBER}.DL{DATALOADER_BUILD_VERSION}.B{backendBuildKey}
        </FooterText>
      </FooterBuildContainer>
      <FooterCopyrightContainer>
        <FooterText isDarkMode={isDarkMode}>
          Copyright &copy;
          {copyrightStartYear}
          {' - '}
          {copyrightEndYear}{' '}
          <FooterLink isDarkMode={isDarkMode} href="https://55degrees.se" target="_new">
            55 Degrees AB
          </FooterLink>
          . All rights reserved. The name ActionableAgile and related logos are trademarks of AMH
          Alba LLC.
        </FooterText>
      </FooterCopyrightContainer>
    </FooterWrapper>
  );
}

export default Footer;
